export default __webpack_public_path__ + "images/0xb33eaad8d922b1083446dc23f610c2567fb5180f.png";